import * as React from 'react';

export const InfoIcon: React.FC = () => {
  return (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle
          fill="#1a66ff"
          fillRule="nonzero"
          cx="9"
          cy="9"
          r="9"
        />
        <g strokeLinejoin="round" stroke="#FFF" strokeWidth="1.4">
          <path strokeLinecap="round" d="M7 13.4h4M7.7 8H9v5.4" />
          <path
            d="M8.5 4c-.3 0-.5.2-.5.4 0 .3.2.5.5.5.2 0 .5-.2.5-.5 0-.2-.3-.4-.5-.4h0z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  );
};
